<article class="responsive-6-6">
	<header class="page-header">
		<div class="breadcrumb-line">
			<stages-breadcrumb [links]="true" [path]="breadcrumb"></stages-breadcrumb>
			@if (self) {
				<stages-process-version [type]="self.type?.ident" [identity]="self.identity"></stages-process-version>
			}
		</div>
		@if (self) {
			<stages-element-name [self]="$any(self)"></stages-element-name>
		}
	</header>

	<ng-container stagesSlot="top"></ng-container>

	<div class="container row">
		<div class="container column col-6">
			<ng-container stagesSlot="left"></ng-container>
		</div>
		<div class="container column col-6">
			<ng-container stagesSlot="right"></ng-container>
		</div>
	</div>
</article>
